














































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldBlockoutDates'

  vue:
    props: ['value', 'errors']

    data: ->
      dates = @value || []
      dates: dates
      isActive: dates.length > 0

    computed:
      datesTableData: ->
        @dates

    methods:
      hiAdd: ->
        @add()
        @inputChanged()

      hiRemove: (index) ->
        @remove index
        @inputChanged()

      hiInputChanged: ->
        @inputChanged()

      add: ->
        name = "Date #{@dates.length + 1}"
        today = dayjs().format('YYYY-MM-DD')
        starts_on = today
        ends_on = today
        @dates.push { name, starts_on, ends_on }

      remove: (index) ->
        @dates.splice index, 1

      clear: ->
        @dates = []

      inputChanged: ->
        @$emit 'input', @dates
        @$emit 'change', @dates

    watch:
      isActive: (active) ->
        if active
          if @dates.length is 0
            @add()
        else
          @clear()
        @inputChanged()

export default VueOptions.vue settings
